import React from 'react';
import { useFormContext } from 'react-hook-form';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';
import styles from './text-area.module.scss';

const TextArea = ({
  label,
  id,
  rows,
  name,
  value,
  validation,
  disabled,
  onChange,
  onBlur,
  maxLength,
  ...props
}) => {
  const formMethods = useFormContext();
  const register = formMethods?.register ? formMethods?.register : () => {};
  const formProps = register ? { ...register(name, { ...validation }) } : {};

  const handleChange = (e) => {
    formProps?.onChange?.(e);
    onChange?.(e.target.value);
  };

  const handleBlur = (e) => {
    formProps?.onBlur?.(e);
    onBlur?.(e.target.value);
  };

  return (
    <>
      {label && <label htmlFor={id}>{label}</label>}
      <textarea
        {...applyProps(props)}
        value={value}
        id={id}
        name={name}
        className={cn(
          styles.textArea,
          { [styles.disabled]: disabled },
          applyClasses(props, styles)
        )}
        rows={rows}
        disabled={disabled}
        {...formProps}
        onChange={handleChange}
        onBlur={handleBlur}
        maxLength={maxLength}
      />
    </>
  );
};

TextArea.propTypes = {
  /** The string or component to label the input */
  label: PropTypes.any,
  /** The id for the element */
  id: PropTypes.string,
  /** The number of rows in the textarea, defaults to 5 */
  rows: PropTypes.number,
  /** The name of the input */
  name: PropTypes.string,
  /** The default value of the input */
  defaultValue: PropTypes.string,
  /** The value of the input when used outside of a Form component */
  value: PropTypes.string,
  /** The validation object the input */
  validation: PropTypes.object,
  /** Whether or not the input is disabled */
  disabled: PropTypes.bool,
  /** Callback called when the input is changed */
  onChange: PropTypes.func,
  /** Callback called when the input is unfocused */
  onBlur: PropTypes.func,
  /** The maximum number of characters that can be entered in the input */
  maxLength: PropTypes.number,
};

TextArea.defaultProps = {
  rows: 5,
};

export default TextArea;
